import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ConnectTinder = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.237 11.161a5.597 5.597 0 1 0 0 11.194 5.597 5.597 0 0 0 0-11.194Zm-7.41 5.597a7.41 7.41 0 1 1 14.82 0 7.41 7.41 0 0 1-14.82 0ZM13.237 28.387a8.276 8.276 0 0 0-8.28 8.28v2.973c0 .394.319.713.713.713h15.134c.394 0 .713-.319.713-.713v-2.973a8.276 8.276 0 0 0-8.28-8.28Zm-10.094 8.28a10.09 10.09 0 0 1 10.094-10.094A10.09 10.09 0 0 1 23.33 36.667v2.973a2.526 2.526 0 0 1-2.526 2.527H5.67a2.526 2.526 0 0 1-2.527-2.527v-2.973ZM30.764 8.917a5.597 5.597 0 1 0 0 11.194 5.597 5.597 0 0 0 0-11.194Zm-7.41 5.597a7.41 7.41 0 1 1 14.82 0 7.41 7.41 0 0 1-14.82 0ZM30.764 26.13a8.274 8.274 0 0 0-5.874 2.443.907.907 0 0 1-1.282-1.282 10.087 10.087 0 0 1 7.156-2.974 10.09 10.09 0 0 1 10.094 10.094v2.974a2.526 2.526 0 0 1-2.527 2.526h-9.767a.907.907 0 1 1 0-1.813h9.767c.394 0 .713-.32.713-.713V34.41a8.276 8.276 0 0 0-8.28-8.28ZM17.014 2.088a2.862 2.862 0 0 1 3.98 0 2.862 2.862 0 0 1 3.979 0c1.11 1.073 1.11 2.861 0 3.845l-3.517 3.399a.744.744 0 0 1-1.018 0l-3.424-3.31c-1.111-1.162-1.111-2.861 0-3.934Zm1.018.983c-.556.537-.556 1.342 0 1.878l2.961 2.862 2.962-2.862c.555-.536.555-1.341 0-1.878a1.374 1.374 0 0 0-1.944 0l-.463.447a.745.745 0 0 1-1.018 0l-.462-.447c-.648-.536-1.481-.536-2.037 0Z"
  }));
});
ConnectTinder.displayName = 'ConnectTinder';
ConnectTinder.defaultProps = {
  'aria-label': 'ConnectTinder'
};
export default ConnectTinder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/ConnectTinder.js
// module id = 3758
// module chunks = 11